interface Action {
    payload: any,
    type: string,
    field: string,
    subfield?: string
    value?: { length?: number },
    validate: boolean,
}

const errors: {
    [key: string]: string
} = {
    state: "Please select a state.",
    county: "Please select a county.",
    caseType: "Please select a case type.",
    caseSubType: "Please select a sub type.",
    description: "Please add description.",
    language: "Please select a language.",
    descriptionLength:"The description should be at least 40 characters long."
};

export default (data: any, action: Action) => {

    const newForm = {...data};
    const prop = newForm[action.field];
    const length = action?.value?.length || 0;

    if (prop) {
        action.value = action.value === ' ' ? '' : action.value;
        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true
        }

        prop.error = (prop.added && !action.value && prop.required) || (prop.min && prop.min > length) ? errors[action.field] : null;
        if(action.field === 'description' && length < 40){
            prop.error = errors.descriptionLength
        }
        prop.value = action.value;

    }
    const vals = Object.values(newForm).filter((f: any) => f.required);
    const valid = vals.filter((f: any) => f.added && f.value && !f.error);
    return {
        changed: true,
        valid: vals.length === valid.length,
        data: newForm,
    };
};
